<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="14.849" height="14.849" viewBox="0 0 14.849 14.849">
    <g id="Gruppe_15" data-name="Gruppe 15" transform="translate(-336.919 -664.711)">
      <rect id="Rechteck_27" data-name="Rechteck 27" width="19" height="2" rx="1" transform="translate(338.333 664.711) rotate(45)" fill="#fff"/>
      <rect id="Rechteck_28" data-name="Rechteck 28" width="19" height="2" rx="1" transform="translate(336.919 678.146) rotate(-45)" fill="#fff"/>
    </g>
  </svg>
</template>

<script>
export default {
name: "closeBtn"
}
</script>

<style scoped>

</style>